import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const AboutHero = () => {
  const navigate = useNavigate();

  const handleViewPortfolio = () => {
    navigate('/portfolio');
  };

  return (
    <section className="pb-8 flex flex-col gap-6 start md:items-center px-4 mx-auto">
      <h1 className="text-2xl lg:text-5xl text-start font-bold text-gray-900 md:hidden">
              About We Tekup
            </h1>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 md:gap-8 items-center">
        {/* Right Content - First on mobile, second on desktop */}
        <div className="flex items-center justify-center relative min-h-[300px] md:min-h-[650px] order-1 lg:order-2">
          {/* Background Logo */}
          <div 
            className="absolute inset-0 bg-no-repeat bg-center bg-contain opacity-5 bg-[length:70%] md:bg-[length:77%]"
            style={{
              backgroundImage: 'url(/wetekuplogo.svg)',
              backgroundPosition: 'right'
            }}
          />
          
          <div className="text-center relative z-10">
            <h2 className="text-3xl max-w-[400px] lg:text-5xl font-bold text-start leading-tight">
              Turn your Vision
              into a System
              that performs.
            </h2>
          </div>
        </div>

        {/* Left Content - Second on mobile, first on desktop */}
        <div className="space-y-2 md:space-y-8 md:pl-32 order-2 lg:order-1">
          <div>
            <h1 className="text-2xl lg:text-5xl font-bold text-gray-900 mb-6 max-md:hidden">
              About We Tekup
            </h1>
            
            <div className="mb-8">
              <p className="text-lg text-gray-700 font-light mb-2">
                We Tekup launched on{' '} <br className='md:hidden' />
                <span className="bg-primary-blue text-white px-1 py-1 max-md:text-2xl font-medium">
                  7 January 2025 in Tunisia.
                </span>
              </p>
            </div>

            <div className="text-black  text-base font-regular leading-normal">
              <p>
                WE TEKUP is a Tunisia-based digital agency and IT partner specializing in web development, e-commerce, mobile applications, branding, and digital growth.
              </p>
              <p className='max-md:mb-2'>
                We create modern, high-performance digital experiences designed to help businesses grow locally and internationally combining strategy, design, technology, and execution under one vision.
              </p>
              <p>
                From custom websites and mobile apps to UI/UX design, SEO, and digital marketing, our work is built with one goal: delivering solutions that are fast, scalable, and meaningful.
              </p>
              <p>
                Driven by a young and ambitious team, WE TEKUP works with businesses in Tunisia and abroad to transform ideas into powerful digital products.
              </p>
              <p>
                Most new agencies spend years finding their rhythm. We found ours in months.
              </p>
              <p>
                Why? Because we built something rare:
              </p>
              <p>
                A team that feels like family. Clients who feel like partners. Work that feels like art and engineering at the same time.
              </p>
              <p>
                Websites. Apps. Branding. Print. Photography. Videography.
              </p>
              <p>
                We are young, ambitious, and eager to do what no one has done before.
              </p>
            </div>
          </div>
          <div className="flex justify-start">
            <button
              onClick={handleViewPortfolio}
              className="inline-flex items-center gap-3 bg-primary-blue text-white px-3 md:px-4 py-1 md:py-2 rounded-full font-medium text-lg hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 group"
            >
              <span className='md:text-lg text-base'>View our portfolio</span>
              <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1">
                <FaArrowRight className="text-black text-sm" />
              </div>
            </button>
          </div>
        </div>
      </div>
      
    </section>
  );
};

export default AboutHero;